import { useState } from 'react';
import useUserStore from '@/stores/UserStore';
import { toast } from 'sonner';

export const useOpensPopup = () => {
  const [loading, setLoading] = useState(false);
  const [messageHandled, setMessageHandled] = useState(false);
  const setOpensSessionActive = useUserStore((s) => s.setOpensSessionActive);

  const openOpensPopup = async () => {
    setLoading(true);
    setMessageHandled(false);

    try {
      const popup = window.open(
        `${window.location.origin}/opens/login`,
        'opens-auth',
        'width=460,height=560,scrollbars=yes,resizable=yes,location=no,toolbar=no,menubar=no,status=no'
      );

      if (!popup) {
        toast.error('Popup blocked. Please allow popups for this site.');
        setLoading(false);
        return;
      }

      // Monitor popup; if closed manually and not handled, reload
      const closeCheck = setInterval(() => {
        if (popup.closed) {
          clearInterval(closeCheck);
          setLoading(false);
          if (!messageHandled) {
            window.location.reload();
          }
        }
      }, 800);

      const handleMessage = (event) => {
        if (event.origin !== window.location.origin) return;
        if (event.data && event.data.type === 'OPENS_AUTHENTICATED') {
          setMessageHandled(true);
          setLoading(false);
          if (event.data.success) {
            setOpensSessionActive(true);
            toast.success(event.data.message || 'Authenticated successfully');
          } else {
            toast.error(event.data.message || 'Authentication failed');
          }
          window.removeEventListener('message', handleMessage);
        }
      };
      window.addEventListener('message', handleMessage);
    } catch (e) {
      toast.error('Failed to open authentication popup');
      setLoading(false);
    }
  };

  return { openOpensPopup, loading };
};
